import { Grid, Typography } from "@mui/material"
import React from "react"
import useStyles from "./useStyles"
import formatDate from "../../utils/formatDate"

const DetailsBox = ({ data, config = [] }) => {
  const classes = useStyles()

  function getComponent(comp) {
    switch (comp.type) {
      case "string":
        return (
          <Grid item xs={8}>
            <Typography
              style={{
                fontSize: 16,
                fontWeight: "bold",
                color: "#6e7a76",
              }}
            >
              {data[comp.value] || ' - '}
            </Typography>
          </Grid>
        )
      case "boolean":
        return (
          <Grid item xs={8}>
            <Typography
              style={{
                fontSize: 16,
                fontWeight: "bold",
                color: "#6e7a76",
              }}
            >
              {data[comp.value] ? "Si" : "No"}
            </Typography>
          </Grid>
        )
      case "date":
        return (
          <Grid item xs={8}>
            <Typography
              style={{
                fontSize: 16,
                fontWeight: "bold",
                color: "#6e7a76",
              }}
            >
              {formatDate(data[comp.value])}
            </Typography>
          </Grid>
        )
      default:
        break
    }
  }
  return (
    data && (
      <Grid container className={classes.boxDetails}>
        <Grid item xs={12}>
          <Typography
            style={{
              fontSize: 20,
              fontWeight: "bold",
              color: "#4B4952",
              paddingLeft: 10,
              borderBottom: "1px solid rgba(36, 55, 143, 0.2)",
            }}
          >
            Detalles
          </Typography>
        </Grid>
        <Grid container style={{ padding: 10 }}>
          {config.map((comp) => (
            <>
              <Grid item xs={4}>
                <Typography
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    color: "#485450",
                  }}
                >
                  {comp.label}
                </Typography>
              </Grid>
              {getComponent(comp)}
            </>
          ))}
        </Grid>
      </Grid>
    )
  )
}

export default DetailsBox
